import pendingForQuotationImg from "../../assets/pendingForQuotation.svg";
import underReviewImg from "../../assets/underReview.svg";
import activeOrderImg from "../../assets/activeOrders.svg";
import unapprovedImg from "../../assets/unapprovedQuotes.svg";
import closedOrderImg from "../../assets/closedOrders.svg";
import shippedImage from "../../assets/shipped-icon.svg";
import deliveryImage from "../../assets/delivery-icon.svg";

import { useEffect, useContext, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import BucketFilterTile from "../../component/BucketFilterTile";
import { OrdersContext } from "../../context/orders.context";
import {
  fetchOrderForSupplier,
  fetchQuotationsForSupplier,
  getOrderForSupplier,
} from "../../utils/actions/userActions";
import moment from "moment";
import { Loading } from "../../component/Loading";
import { checkIfAllPartsInvoicedForPO } from "../../utils/helper";
import HoverTiltComponent from "../../component/AnimatedComponents/HoverTiltComponent";
import {
  BanIcon,
  BilledIcon,
  CompleteIcon,
  CopyIcon,
  SettingIcon,
  TimerIcon,
} from "../../component/icons";
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer ,Cell} from "recharts";

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A28EF5', '#FF6699'];


const Dashboard = () => {
  let token = localStorage.getItem("Token");
  let userName = localStorage.getItem("firstName");
  const loggedInUser = localStorage.getItem("Token");
  const supplierId = localStorage.getItem("supplierId");
  const { ordersCount, setOrdersCount } = useContext(OrdersContext);
  const [isLoading, setIsLoading] = useState(false);
  console.log(JSON.stringify(ordersCount));
  const data01 = [
    { name: "Pending For Quotation", value: ordersCount.pendingForQuotation },
    { name: "Under Review", value: ordersCount.underReview },
    { name: "Active Orders", value: ordersCount.activeOrders },
    { name: "Billed Orders", value: ordersCount.billedOrders },
    { name: "Completed Orders", value: ordersCount.closedOrders },
    { name: "Unapproved Quotes", value: ordersCount.unapprovedQuotes },
  ];

  const navigate = useNavigate();

  useEffect(() => {
    let decode;
    if (token) {
      decode = jwt_decode(token);
      if (!decode) {
        navigate("/");
        toast.error("Invalid Token found!");
        return;
      } else if (decode.userType == "admin") {
        navigate("/");
        return;
      } else if (decode.exp * 1000 < Date.now()) {
        navigate("/");
        return;
      } else {
        fetchData();
      }
    } else {
      
    }
  }, []);
  const fetchData = async()=>
  {
    setIsLoading(true);
    try {
      const response = await getOrderForSupplier('count',loggedInUser,supplierId);
      if(response && response.success)
      {
        const count = response.count;
        const activeOrder = count['Active Orders'];
        const billedOrder = count['Billed Orders'];
        const closedOrder = count['Closed Orders'];
        const pendingOrder = count['Pending for Quotation'];
        const unapprovedorder = count['Unapproved'];
        const underRevieworder = count['Under Review'];
        setOrdersCount({
          pendingForQuotation:pendingOrder,
          underReview:underRevieworder,
          activeOrders:activeOrder,
          shippedOrders:0,
          deliveredOrders:0,
          unapprovedQuotes:unapprovedorder,
          closedOrders:closedOrder,
          billedOrders:billedOrder,
        })
      }
      
    } catch (error) {
      toast.error("Unable To Load Data");
    }finally
    {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <div className="content-wrapper">
        {loggedInUser ? (
          <div>
            {isLoading ? (
              <>
                <Loading />
              </>
            ) : (
              <>
                <div>
                  <div className="intro-bar border shadow-sm">
                    <div className="int-left">
                      <h3>Hey {userName ? userName : ""} Welcome!</h3>
                      <p>
                        The power of digital manufacturing at your fingertips
                      </p>
                    </div>
                    <div className="int-right"></div>
                  </div>
                  <h4 className="text-xl md:text-2xl lg:text-3xl text-center my-2">Overview</h4>
                  <div className=" !px-2  lg:!px-20 my-2 flex flex-col md:flex-row ">
                    <div className="basis-1/3 min-h-[130px] p-10 w-screen  flex items-center justify-center">
                      <ResponsiveContainer >
                        <PieChart width="100%" height="100%">
                          <Pie
                            dataKey="value"
                            isAnimationActive={true}
                            data={data01}
                            cx="50%"
                            cy="50%"
                            outerRadius={80}
                            label
                          >
                            {data01.map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={COLORS[index % COLORS.length]}
                              />
                            ))}
                          </Pie>
                          <Tooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="basis-2/3 grid grid-cols-2 lg:grid-cols-3   bg-slate-100 rounded place-items-center gap-2 px-2 py-5    ">
                      <HoverTiltComponent
                        name="Pending For Quotation"
                        count={ordersCount.pendingForQuotation}
                        href="/my-orders"
                        state='pending-for-quotation'
                        Icon={TimerIcon}
                        iconBgClass="bg-gray-100"
                        iconClass="text-gray-600"
                      />
                      <HoverTiltComponent
                        name="Under Review"
                        count={ordersCount.underReview}
                        href="/my-orders"
                        state='under-review'
                        Icon={CopyIcon}
                        iconBgClass="bg-yellow-100"
                        iconClass="text-yellow-600"
                      />
                      <HoverTiltComponent
                        name="Active Orders"
                        count={ordersCount.activeOrders}
                        href="/my-orders"
                        state='active-orders'
                        Icon={SettingIcon}
                        iconBgClass="bg-blue-100"
                        iconClass="text-blue-600"
                      />
                      <HoverTiltComponent
                        name="Billed Orders"
                        count={ordersCount.billedOrders}
                        href="/my-orders"
                        state='billed-orders'
                        Icon={BilledIcon}
                        iconBgClass="bg-emerald-100"
                        iconClass="text-emerald-600"
                      />
                      <HoverTiltComponent
                        name="Completed Orders"
                        count={ordersCount.closedOrders}
                        href="/my-orders"
                        state='closed-orders'
                        Icon={CompleteIcon}
                        iconBgClass="bg-green-100"
                        iconClass="text-green-700"
                      />

                      <HoverTiltComponent
                        name="Unapproved Quotes"
                        count={ordersCount.unapprovedQuotes}
                        href="/my-orders"
                        state='unapproved-quotes'
                        Icon={BanIcon}
                        iconBgClass="bg-red-100"
                        iconClass="text-red-700"
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default Dashboard;
